// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"styles_loaderContainer__P88m8"};